import React from 'react';
import useTranslation from '@/hooks/useTranslation';
import { Box, Drawer, Flex, List } from '@thebouqs/ui';
import { HamburgerIcon } from '@thebouqs/icons';
import TopMenu from './TopMenu';
import NavDotw from '../NavDotw';
import NavLogo from '../NavLogo';
import NavLogin from '../NavLogin';
import { DrawerMenuStyles } from './DrawerMenu.styles';

const DrawerMenuContent = (): JSX.Element => {
  return (
    <Box as="nav" padding="md">
      <Flex as="header" marginBottom="4">
        <NavLogo isDrawer={true} />
      </Flex>
      <NavLogin />
      <NavDotw />
      <List
        margin="none"
        marginBottom="4"
        paddingY="4"
        sx={DrawerMenuStyles}
        className="drawer-menu">
        <TopMenu />
      </List>
    </Box>
  );
};

const DrawerMenu = (): JSX.Element => {
  const { t } = useTranslation();
  const navigationName = t('header.navigation');

  return (
    <Drawer
      direction="left"
      aria={{
        closeButtonLabel: t('aria.label.closeName', {
          name: navigationName,
        }),
        handleLabel: t('aria.label.openName', { name: navigationName }),
        bodyLabel: navigationName,
      }}
      icon={<HamburgerIcon w="7" h="7" color="text" />}>
      {/* TODO: Expose open state from Drawer so we can avoid rendering this content until the drawer is opened */}
      <DrawerMenuContent />
    </Drawer>
  );
};

export default DrawerMenu;
